import React, { Fragment } from "react";
import screenshot_1 from "../../../assets/media/DeveloperIntegration/Guides/screenshot_1.png";
import screenshot_2 from "../../../assets/media/DeveloperIntegration/Guides/screenshot_2.png";
import screenshot_3 from "../../../assets/media/DeveloperIntegration/Guides/screenshot_3.png";
const Standalone = () => {
  return (
    <Fragment>
      <h2>How to embed your Ecosystem into your app or website</h2>
      <p style={{ marginBottom: 30 }}>
        We’ve made integrating the front end iframe and data API simple for
        proficient developers. It doesn't matter what you are developing and
        whether it’s web or mobile, the solution works elegantly for any
        approach with the following tools:
      </p>
      <b>Data travelling from your Ecosystem to your database</b>
      <p style={{ fontSize: 14, paddingLeft: 20, marginBottom: 20 }}>
        1. User token earnings <br />
        2. User live token total <br />
        3. User token spending via ecopay <br />
        4. User token spending via Marketplace (coming soon) <br />
        5. Page navigation <br />
        6. Generate user profile via first name <br />
      </p>
      <b>Data travelling from your database to your Ecosystem</b>
      <p style={{ fontSize: 14, paddingLeft: 20, marginBottom: 20 }}>
        1. New User with First Name creates UID on ecosystem side <br />
        2. User Active or de-active <br />
        3. Back and forwards on pages <br />
        4. Tokens allocated to user a Ecosystem Community user from 3rd party
        platform triggers <br />
      </p>
      <p>
        You should navigate the user to the desired page e.g.review page, by
        calling our navigation endpoint which Ecosystem provides or by simply
        placing the stand alone iframe page for e.g reviews into a dedicated tab
        for reviews in your site.
      </p>
      <p>
        You can navigate your user to a certain page through the navigation api
        which is shown as a working api through postman in the screenshot below.
        You can access this information for all pages and tools via your
        Ecosystem Integrate sub tab <b>Ecosystem feature plugins</b>.
      </p>
      <img src={screenshot_2} width="80%" />
      <p>
        Place the iframe of ecosystem in your page below your navigation bar.
      </p>
      Your iframe url will be{" "}
      <b>https://ecosystem.club/[your brand]?uid=[uid of your user]</b>
      <p>
        Or you can redirect your single page to this url on your application to
        show the full page.
      </p>
      <p>
        We’ve made the iframe and API combination an easy journey, but if you
        have any issues or queries then then please contact our technical
        support team through the technical support sub tab, submit and ticket
        and we’ll help to guide you to your desired solution.
      </p>
    </Fragment>
  );
};
export default Standalone;



// WEBPACK FOOTER //
// ./src/screens/DeveloperIntegration/Guides/Standalone.js